import { SxProps } from '@mui/material'

export default {
  footer: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: 2,
    alignItems: 'center',
    justifyContent: 'center',
    p: 3,
    textAlign: 'center',
    borderTop: '1px solid',
    backgroundColor: '#FEF8F3',
  },
  mobileVisible: {
    display: { xs: 'block', md: 'none' },
    marginTop: 1,
  },
  desktopVisible: {
    display: { xs: 'none', md: 'block' },
  },
} satisfies SxProps
